<template>
  <div>
    <v-progress-circular indeterminate color="orange-darken-2" v-show="preLoading" :size="70" :width="4"></v-progress-circular>
    <vehicle-type-form
      :vehicleType="vehicleType"
      :submit="submit"
      :buttonText="t('edit')"
      :onInput="() => {}"
      :loading="loading"
      v-if="!preLoading"
    />
  </div>
</template>

<script setup lang="ts">
import VehicleTypeForm from './Form.vue'
import Say from '@/utils/Say'
import { defineComponent, ref, computed, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import { vehicleTypeStore } from '@/store/vehicleTypes'
import { useRoute } from 'vue-router';
import sayErrorResponse from '@/mixins/sayErrorResponse'

const { t } = useI18n()
const route = useRoute()

defineComponent({
  VehicleTypeForm
})

const preLoading = ref(true)
const loading = ref(false)

const vehicleType = computed(() => {
  store.commit('app.setPageTitle', t('vehicleTypeEdit') + ' ' + vehicleTypeStore.getters.vehicleType.name)
  store.commit('app.setBreadcrumbs', [
    { text: t('vehicleType', 2), routeName: 'VehicleTypesList' },
    { text: t('vehicleTypeEdit') + ' ' + vehicleTypeStore.getters.vehicleType.name }
  ])
  return vehicleTypeStore.getters.vehicleType
})

onBeforeMount(() => {
  vehicleTypeStore.dispatch('fetchVehicleType', route.params.id)
    .then(() => {
      preLoading.value = false
    })
})

const submit = (imageFile: File | null) => {
  loading.value = true

  const formData = new FormData()
  formData.append('name', vehicleType.value.name || '')
  formData.append('brand', vehicleType.value.brand || '')
  formData.append('model', vehicleType.value.model || '')
  if (imageFile) {
    formData.append('image', imageFile)
  }

  vehicleTypeStore.dispatch('updateVehicleType', { id: vehicleType.value.id, data: formData }).then(() => {
    loading.value = false
    Say('success', t('vehicleTypeEditSuccess'))
  }).catch((err: any) => {
    loading.value = false
    sayErrorResponse(err)
  })
}
</script>
